module.exports = __webpack_public_path__ + "static/media/kid-pouring-sprinkles.6383b6e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2017-11-4/kid-pouring-sprinkles.jpg
// module id = 809
// module chunks = 0